import { saveAs } from "file-saver";

export async function downloadTicketXLSX(report) {
  const ExcelJS = (await import("exceljs")).default;

  const wb = new ExcelJS.Workbook();
  const ws = wb.addWorksheet("Тасалбарын тайлан");

  const border = { style: "thin", color: { argb: "FFBFBFBF" } };
  const setBorder = (c) =>
    (c.border = { top: border, left: border, bottom: border, right: border });

  const center = { horizontal: "center", vertical: "middle" };
  const leftMid = { horizontal: "left", vertical: "middle" };
  const money = "#,##0.00;[Red]-#,##0.00";

  // ===== HEADER (MERGE) =====
  ws.mergeCells("A1:A2");
  ws.getCell("A1").value = "№";
  ws.getCell("A1").alignment = center;
  ws.getCell("A1").font = { bold: true };
  ws.getCell("A1").fill = {
    type: "pattern",
    pattern: "solid",
    fgColor: { argb: "FFD9D9D9" },
  };
  setBorder(ws.getCell("A1"));

  ws.mergeCells("B1:B2");
  ws.getCell("B1").value = "Утасны дугаар";
  ws.getCell("B1").alignment = center;
  ws.getCell("B1").font = { bold: true };
  ws.getCell("B1").fill = {
    type: "pattern",
    pattern: "solid",
    fgColor: { argb: "FFD9D9D9" },
  };
  setBorder(ws.getCell("B1"));

  ws.mergeCells("C1:H1");
  ws.getCell("C1").value = "Сугалаа";
  ws.getCell("C1").alignment = center;
  ws.getCell("C1").font = { bold: true };
  ws.getCell("C1").fill = {
    type: "pattern",
    pattern: "solid",
    fgColor: { argb: "FFE0E0E0" },
  };
  ws.getCell("C1").border = {
    right: { style: "thin", color: { argb: "FF808080" } },
  };

  ws.getCell("C2").value = "Prefix";
  ws.getCell("D2").value = "Нэгж үнэ";
  ws.getCell("E2").value = "Тоо ширхэг";
  ws.getCell("F2").value = "Хугацаа";
  ws.getCell("G2").value = "Нийт";
  ws.getCell("H2").value = "Нөат";

  ["C2", "D2", "E2", "F2", "G2", "H2"].forEach((addr) => {
    const c = ws.getCell(addr);
    c.alignment = center;
    c.font = { bold: true };
    c.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "FFD9D9D9" },
    };
    setBorder(c);
  });

  // ===== DATA =====
  const rows = Array.isArray(report?.rows) ? report.rows : [];

  for (const r of rows) {
    const prefixes = Array.isArray(r?.prefixes) ? r.prefixes : [];

    // prefix байхгүй бол нэг мөр л гаргая (optional)
    if (!prefixes.length) {
      const row = ws.addRow([
        r?.no ?? null,
        r?.phone ?? "",
        "",
        null,
        null,
        "",
        null,
      ]);
      row.height = 18;
      row.eachCell((c) => setBorder(c));
      row.getCell(1).alignment = center;
      row.getCell(2).alignment = center;
      continue;
    }

    // энэ phone group эхлэх мөр
    const startRow = ws.lastRow.number + 1;

    // prefix мөрүүдийг шууд addRow хийнэ (A,B хоосон)
    for (const p of prefixes) {
      const dateText = formatDateOnly(p?.updated_at);

      const sub = ws.addRow([
        null, // A (merge хийнэ)
        null, // B (merge хийнэ)
        `${p?.prefix || ""}`, // C
        num(p?.unitPrice), // D
        num(p?.qty), // E
        dateText, // F
        num(p?.amount), // G
        num(p?.vat) || "-", // H
      ]);

      sub.height = 18;

      sub.getCell(3).alignment = leftMid;
      sub.getCell(4).alignment = center;
      sub.getCell(5).alignment = center;
      sub.getCell(6).alignment = center;
      sub.getCell(7).alignment = center;
      sub.getCell(8).alignment = center;

      sub.getCell(4).numFmt = money;
      sub.getCell(7).numFmt = money;
      sub.getCell(8).numFmt = money;
    }

    const endRow = ws.lastRow.number;

    // A, B merge -> № ба phone нэг дор “шахагдаж” харагдана
    ws.mergeCells(`A${startRow}:A${endRow}`);
    ws.mergeCells(`B${startRow}:B${endRow}`);

    const a = ws.getCell(`A${startRow}`);
    const b = ws.getCell(`B${startRow}`);

    a.value = r?.no ?? null;
    b.value = r?.phone ?? "";

    a.alignment = center;
    b.alignment = center;

    // a.font = { bold: true };
    // b.font = { bold: true };

    // merge хийсэн cell-үүдэд border баталгаажуулж өгнө
    setBorder(a);
    setBorder(b);
  }

  // ===== 4) НИЙТ ДҮН (Footer) =====
  const total = num(report?.totalAmount) ?? 0;
  const totalVat = num(report?.totalVat) ?? 0;

  const footer = ws.addRow(["", "Нийт", "", "", "", "Нийт", total, totalVat]);
  // B..F merge
  ws.mergeCells(`B${footer.number}:F${footer.number}`);

  footer.height = 20;

  footer.getCell(2).alignment = leftMid;
  footer.getCell(2).font = { bold: true };

  footer.getCell(7).alignment = center;
  footer.getCell(7).font = { bold: true };
  footer.getCell(7).numFmt = money;

  footer.getCell(8).alignment = center;
  footer.getCell(8).font = { bold: true };
  footer.getCell(8).numFmt = money;

  // ===== WIDTHS =====
  ws.getColumn("A").width = 6;
  ws.getColumn("B").width = 16;
  ws.getColumn("C").width = 18;
  ws.getColumn("D").width = 14;
  ws.getColumn("E").width = 12;
  ws.getColumn("F").width = 14;
  ws.getColumn("G").width = 16;
  ws.getColumn("H").width = 16;

  // ===== DOWNLOAD =====
  const buf = await wb.xlsx.writeBuffer();
  const now = new Date();
  const ts = `${now.getFullYear()}${String(now.getMonth() + 1).padStart(2, "0")}${String(
    now.getDate(),
  ).padStart(2, "0")}-${String(now.getHours()).padStart(2, "0")}${String(
    now.getMinutes(),
  ).padStart(2, "0")}${String(now.getSeconds()).padStart(2, "0")}`;

  const filename = `TICKETS-${ts}.xlsx`;

  saveAs(
    new Blob([buf], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    }),
    filename,
  );

  function num(v) {
    const n = Number(v);
    return Number.isFinite(n) ? n : null;
  }

  function formatDateOnly(v) {
    if (!v) return "";
    const d = new Date(v);
    if (Number.isNaN(d.getTime())) return "";
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, "0");
    const dd = String(d.getDate()).padStart(2, "0");
    return `${y}-${m}-${dd}`;
  }
}
